import React from 'react';

import { Title, Image, LinkButton } from 'ui/components/styled';
import { Logo, TimeoutLink } from 'ui/components/shared';
import { AuthLayout } from 'ui/components/layouts';
import { useQuery } from 'hooks';

export const SignUpSuccess = () => {
  const [query] = useQuery();
  const validated = query?.validated === 'true';

  return (
    <AuthLayout justifyContent="center">
      <Logo link="/sign-in" mb="xxl" />
      <Image alt="mail" src="/assets/img/mail.svg" width="200px" mb="xxl" />
      <Title fontSize="24px" mb="s">
        Congrats!
      </Title>
      <Title
        type="h3"
        variant="grey"
        fontSize="18px"
        letterSpacing="0.04em"
        px="20px"
        textAlign="center"
      >
        {validated
          ? 'Your account has been created please sign in.'
          : 'Your account has been created please check your email.'}
      </Title>
      <TimeoutLink
        timeout={validated ? 0 : 10}
        component={LinkButton}
        my="xl"
        width="250px"
        to="/sign-in"
      >
        Log in
      </TimeoutLink>
    </AuthLayout>
  );
};
